import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EventIconsComponent } from '../event-icons/event-icons.component';
import { MomentPipe } from 'src/app/shared/pipes/moment.pipe';

@Component({
  selector: 'app-calendar-month-view',
  templateUrl: './month-view-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, EventIconsComponent, MomentPipe],
})
export class MonthViewEventComponent {
  @Input('event') event;
}
